var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#1ab394",
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.6638 8.08125c.1853.13651.2248.39735.0883.58261l-5.8333 7.91664c-.0673.0913-.1688.1512-.2812.166-.1124.0147-.226-.017-.3145-.0878l-4.16671-3.3333c-.17969-.1438-.20882-.406-.06507-.5857s.40596-.2088.58565-.065l3.82813 3.0625 5.5761-7.56767c.1365-.18526.3974-.22478.5826-.08828z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckedCircle);
export default __webpack_public_path__ + "static/media/green-checked-circle.9d8ed358bc0774ae2e57d8ecce8b5148.svg";
export { ForwardRef as ReactComponent };